import React from 'react'

const ProfileSetupPending = (): JSX.Element => {
  return (
    <div className="profile-setup-pending">
      <div className="profile-setup-pending__content">
        <p className="profile-setup-pending__message">
          Please contact an administrator to finish the setup of your profile
        </p>
      </div>
    </div>
  )
}

export default ProfileSetupPending
